import React from "react";
import { BsInstagram, BsGithub, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { GrMedium } from "react-icons/gr";

const SocialMedia = () => (
  <div className="app__social">
    <a href={"http://linkedin.com/in/carlos-r-morales-b3484b159"} target="_blank" rel="noreferrer">
      <div>
        <BsLinkedin />
      </div>
    </a>
    {/* <div>
      <FaFacebookF />
    </div>
    <div>
      <BsInstagram />
    </div> */}
    <a href={"https://medium.com/@crmorales5dh"} target="_blank" rel="noreferrer">
      <div>
        <GrMedium />
      </div>
    </a>
    <a href={"https://github.com/Charlie5DH"} target="_blank" rel="noreferrer">
      <div>
        <BsGithub />
      </div>
    </a>
  </div>
);

export default SocialMedia;
